import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DefaultLocalQuotaService } from '@asm/features/sync/services/quota/default-local-quota.service';

/**
 * Handler offline para cotas de planejamento de vendas.
 *
 * Cobre:
 * - GET /quota  (query params: page, pageSize)
 */
@Injectable({ providedIn: 'root' })
export class QuotaOfflineHandler {
  private readonly quotaService = inject(DefaultLocalQuotaService);

  canHandle(req: HttpRequest<unknown>): boolean {
    return req.method === 'GET' && req.url.includes('/quota');
  }

  async handle(req: HttpRequest<unknown>): Promise<HttpResponse<unknown>> {
    const page = parseInt(req.params.get('page') ?? '1', 10);
    const pageSize = parseInt(req.params.get('pageSize') ?? '15', 10);

    const body = await this.quotaService.getQuotasByRequester(page, pageSize);
    return new HttpResponse({ status: 200, body });
  }
}
